import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { IQuantumProduct } from 'src/app/interfaces/IQuantum';
import { environment } from 'src/environments/environment';
import { AuthService } from '../auth/auth.service';

@Injectable({
  providedIn: 'root'
})
export class QuantumService {

  uriApiOrder: string = environment.gluky.productsApiBasePath;
  api_key: any;
  token: any;

  constructor(private authService: AuthService,
    private http: HttpClient) { }

  async requestAvailableProductQuantum(skuInfo?, siteId?): Promise<IQuantumProduct> {
    const sku = encodeURIComponent(skuInfo);
    this.api_key = this.authService.apiKey;
    return new Promise((resolve, reject) =>
      this.http
        .post(
          `${this.uriApiOrder}/quantum/available?key=${this.api_key}`,
          JSON.stringify({ sku, siteId: (siteId.toString() ? siteId.toString() : '0') })
        )
        .subscribe(
          (res: any) => {
            resolve(res);
          },
          (err) => {
            reject(err);
          }
        )
    );
  }
  async requestProductQuantum(skuInfo?): Promise<IQuantumProduct> {
    const sku = encodeURIComponent(skuInfo);
    this.api_key = this.authService.apiKey;
    this.token = this.authService.currentAuthTokenValue;
    return new Promise((resolve, reject) =>
      this.http
        .get(
          `${this.uriApiOrder}/quantum/product/${sku}?key=${this.api_key}`,
          {
            headers: new HttpHeaders({
              'Authorization': `Bearer ${this.token}`,
              'Content-Type': 'application/json',
            })
          }
        )
        .subscribe(
          (res: any) => {
            resolve(res);
          },
          (err) => {
            reject(err);
          }
        )
    );
  }
}
